import React from 'react'
import '../../styles/logo-animations.css'

export type HealthStatus = 'operational' | 'warning' | 'critical' | 'unknown'

interface PingLogoProps {
  status?: HealthStatus
  size?: 'small' | 'medium' | 'medium-large' | 'large'
  className?: string
  alt?: string
  useNewStatusClasses?: boolean
  'data-testid'?: string
}

export const PingLogo: React.FC<PingLogoProps> = ({
  status = 'unknown',
  size = 'medium',
  className = '',
  alt = 'Ping Pong Feedback System',
  useNewStatusClasses = true,
  'data-testid': testId = undefined,
}) => {
  const baseClasses = 'ping-logo'
  const statusClasses = useNewStatusClasses 
    ? `logo-status-${status}` 
    : `ping-logo--${status}`
  const sizeClasses = `ping-logo--${size}`
  
  return (
    <div
      className={`${baseClasses} ${statusClasses} ${sizeClasses} ${className}`}
      data-testid={testId}
      role="img"
      aria-label={`${alt} - System status: ${status}`}
    >
      <img
        src="/logo-ping-blue-white-large.png"
        alt={alt}
        className="ping-logo__image"
        loading="lazy"
        decoding="async"
      />
    </div>
  )
} 